import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable react/jsx-props-no-spreading */
import { useI18n } from "@/shared/hooks";
import { useContactingTestId, useCustomerAction } from "@/hooks";
import { Box } from "@gemini/core";
import { Button } from "@gemini/ui";
import { useContactContext, usePlatoAvailable, useProviderSection, } from "@/contexts/contact";
import { BookVisitButton, PhoneButton } from "@/components/contacting/Buttons";
import { NoPhoneInfo } from "@/components/contacting/ProviderSection/NoPhoneInfo";
import { IS_SERVER } from "@/constants";
import { useCallTracking, useCallTrackingPhoneNumbers, } from "@/contexts/callTracking";
import { useConfig } from "@/contexts/cdpConfig";
import { EnvelopeIcon } from "@gemini/icons";
import { useState } from "react";
import { PhoneItem } from "../PhoneContactInfos/PhoneBlock";
const ContactButton = ({ onPress, ...props }) => {
    const { customerActionExposeInteraction } = useCustomerAction();
    const isPreviewMode = useConfig().previewMode;
    const handlePress = async () => {
        await customerActionExposeInteraction([
            { key: "interaction", value: "openContactForm" },
        ]);
        onPress();
    };
    const testId = useContactingTestId("ProviderSection.ContactCard.ContactButton");
    return (_jsx(Button, { ...props, onPress: handlePress, variant: "primary", iconOnly: true, size: "40", icon: EnvelopeIcon, testId: testId, isDisabled: isPreviewMode, children: "contact" }));
};
const Phone = ({ phoneNumbers, testId, }) => {
    const [showPhoneNumbers, setShowPhoneNumbers] = useState(false);
    const { customerActionExposeContactPhoneCall } = useCustomerAction();
    const { isCallTrackingRequestDone } = useCallTracking();
    const virtualPhoneNumbers = useCallTrackingPhoneNumbers();
    const displayedPhoneNumbers = virtualPhoneNumbers !== null && virtualPhoneNumbers !== void 0 ? virtualPhoneNumbers : phoneNumbers;
    const isPreviewMode = useConfig().previewMode;
    const handleShowPhoneNumbers = () => {
        if (isPreviewMode)
            return;
        setShowPhoneNumbers(true);
    };
    const onPressPhoneCall = async (phoneNumber) => {
        if (IS_SERVER || !phoneNumber || isPreviewMode)
            return;
        await customerActionExposeContactPhoneCall();
        window.location.href = `tel:${phoneNumber.replace(/\s/g, "")}`;
    };
    return (_jsx(_Fragment, { children: !showPhoneNumbers || !isCallTrackingRequestDone ? (_jsx(PhoneButton, { trackingAvZone: "detail_agency_block", legacyTrackingInfos: "detail-bottom", rootTestId: testId, iconOnly: true, onPress: handleShowPhoneNumbers, displayPhoneNumbers: true, children: "Tel" })) : (_jsx(Box, { display: "flex", gap: "spacing.12", flexDirection: "column", children: displayedPhoneNumbers.map((phoneNumber, index) => (_jsx(Box, { as: "div", onClick: () => onPressPhoneCall(phoneNumber), pointerEvents: isPreviewMode ? "none" : "auto", children: _jsx(PhoneItem, { index: index, phoneNumber: phoneNumber, testId: testId }, phoneNumber) }, phoneNumber))) })) }));
};
export const ContactCtas = ({ testId }) => {
    var _a;
    const { t } = useI18n();
    const providerSection = useProviderSection();
    const { toggleModal } = useContactContext();
    const isPreviewMode = useConfig().previewMode;
    const isPlatoAvailable = usePlatoAvailable();
    const handlePress = () => {
        if (isPreviewMode)
            return;
        toggleModal({
            av_zone: "detail_agency_block",
            legacyTrackingInfos: "detail-bottom", //tracking GA3 for harvest
        });
    };
    return (_jsxs(Box, { gap: "spacing.16", alignItems: "center", marginLeft: "spacing.24", display: {
            "breakpoint.base": "none",
            "breakpoint.sm": "flex",
        }, children: [((_a = providerSection === null || providerSection === void 0 ? void 0 : providerSection.phoneNumbers) === null || _a === void 0 ? void 0 : _a.length) > 0 ? (_jsx(Phone, { phoneNumbers: providerSection.phoneNumbers, testId: testId })) : (_jsx(NoPhoneInfo, { testId: `${testId}.Nophone` })), isPlatoAvailable && (_jsx(BookVisitButton, { av_zone: "detail_agency_block", rootTestId: testId, iconOnly: true, children: t("contact.cta.book_visit") })), _jsx(ContactButton, { onPress: handlePress })] }));
};
